export default __webpack_public_path__ + "static/header-ad0424c8a8ecb9f3929a29f72942884c.jpeg";